export default {"src":"/_next/static/media/school2.68d9bc3b.svg","height":65,"width":65,"blurWidth":0,"blurHeight":0};